module.exports = __webpack_public_path__ + "img/239-montenegro.9c9d9bed.svg";